import { render, staticRenderFns } from "./HomepageCollections.vue?vue&type=template&id=9984a882&"
import script from "./HomepageCollections.vue?vue&type=script&lang=js&"
export * from "./HomepageCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HomepageCollections.vue"
export default component.exports